import React from 'react';

const STATUS_MAP = {
  open:     'bm-badge--open',
  closed:   'bm-badge--closed',
  resolved: 'bm-badge--resolved',
  primary:  'bm-badge--primary',
};

/**
 * Badge — статусный бейдж.
 *
 * @param {'open'|'closed'|'resolved'|'primary'} status
 * @param {boolean} pulse — показывать живой индикатор (только для open)
 */
const Badge = ({ children, status = 'primary', pulse = false, className = '' }) => {
  const modifier = STATUS_MAP[status] || 'bm-badge--primary';

  return (
    <span className={`bm-badge ${modifier} ${className}`}>
      {pulse && <span className="bm-badge__dot" />}
      {children}
    </span>
  );
};

export default Badge;
